"use strict";

exports.__esModule = true;
exports.MeasurementValueWithTimestamp = void 0;
var _react = _interopRequireDefault(require("react"));
var _UnitValue = require("../UnitValue");
var _TextValue = require("../TextValue");
var _approximateFontSize = require("../approximateFontSize");
var _FormattedPlantDate = require("../../Time/FormattedPlantDate");
var _constants = require("../../constants");
var _calculateXY2 = require("../calculateXY");
var _excluded = ["label", "width", "height", "units", "textAnchor", "value", "timestamp", "timezone", "fontSize", "color", "backgroundColor", "hideMtcAgentUnits"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var MeasurementValueWithTimestamp = exports.MeasurementValueWithTimestamp = function MeasurementValueWithTimestamp(props) {
  var label = props.label,
    width = props.width,
    height = props.height,
    units = props.units,
    _props$textAnchor = props.textAnchor,
    textAnchor = _props$textAnchor === void 0 ? _constants.TEXT_ANCHOR_MIDDLE : _props$textAnchor,
    value = props.value,
    timestamp = props.timestamp,
    timezone = props.timezone,
    fontSize = props.fontSize,
    color = props.color,
    backgroundColor = props.backgroundColor,
    hideMtcAgentUnits = props.hideMtcAgentUnits,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var labelFontSize = 0;
  var labelHeight = 0;
  var labelToShow = undefined;
  if (typeof label === "string" && label.length > 0) {
    labelHeight = Math.min(40, Math.max(14, height / 8));
    labelFontSize = (0, _approximateFontSize.approximateFontSize)({
      width: width,
      height: labelHeight,
      value: label
    });
    labelToShow = label;
  }
  var _calculateXY = (0, _calculateXY2.calculateXY)({
      width: width,
      height: height,
      textAnchor: textAnchor
    }),
    x = _calculateXY.x;
  var formattedTimestamp = null;
  if (timestamp && timezone) {
    formattedTimestamp = (0, _FormattedPlantDate.formatDateString)(timestamp, {
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: timezone
    });
  }
  var timestampHeight = height - labelHeight; // TextValue takes height as half of this value
  var valueHeight = height - labelHeight;
  var valueFontSize = fontSize || (0, _approximateFontSize.approximateFontSize)({
    width: width,
    height: height / 3,
    value: value
  });
  var timestampFontSize = fontSize ? fontSize - 4 : (0, _approximateFontSize.approximateFontSize)({
    width: width,
    height: timestampHeight / 6,
    value: formattedTimestamp
  });
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: width,
    height: height
  }, extra, {
    "data-testid": "MeasurementValueWithTimestamp"
  }), backgroundColor && /*#__PURE__*/_react["default"].createElement("rect", {
    x: 0,
    y: 0,
    width: width,
    height: height,
    fill: backgroundColor
  }), !units ? /*#__PURE__*/_react["default"].createElement(_TextValue.TextValue, {
    width: width,
    height: valueHeight,
    value: value == null ? "" : String(value),
    textAnchor: textAnchor,
    fontSize: valueFontSize,
    fill: color || "currentColor",
    color: color
  }) : /*#__PURE__*/_react["default"].createElement(_UnitValue.UnitValue, {
    width: width,
    height: valueHeight,
    value: value,
    units: units,
    textAnchor: textAnchor,
    fontSize: valueFontSize,
    fill: color || "currentColor",
    color: color,
    hideMtcAgentUnits: hideMtcAgentUnits
  }), formattedTimestamp && value !== null && value !== "" ? /*#__PURE__*/_react["default"].createElement(_TextValue.TextValue, {
    width: width,
    dataTestId: "timestamp",
    height: timestampHeight,
    value: formattedTimestamp === null ? "" : String(formattedTimestamp),
    textAnchor: textAnchor,
    fontSize: timestampFontSize,
    fill: color || "currentColor",
    color: color,
    subText: true
  }) : null, labelToShow && /*#__PURE__*/_react["default"].createElement("text", {
    x: x,
    y: height - labelHeight,
    fontSize: labelFontSize,
    fill: color || "currentColor",
    textAnchor: textAnchor,
    alignmentBaseline: "hanging",
    color: color
  }, labelToShow));
};